
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.999 30.25c7.594 0 13.75-6.156 13.75-13.75S29.593 2.75 21.999 2.75 8.249 8.906 8.249 16.5s6.156 13.75 13.75 13.75z","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.999 24.75a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5zM30.25 27.499v13.75l-8.251-4.124-8.249 4.125V27.5","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    